import { CheckCircle2, History, Lock, Pencil, Trash2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useHasPermission } from "@/hooks/use-auth";

import type { Expense } from "@artisancode/api-types";

export function canShowDeleteExpenseAction(
  status: string,
  canDelete: boolean,
  canDeletePosted: boolean,
): boolean {
  return status === "done" ? canDelete && canDeletePosted : true;
}

export function ExpenseRowActions({
  item,
  canUpdate,
  canDelete,
  canDeletePosted,
  canApprove,
  onEdit,
  onComplete,
  onDelete,
  onHistory,
}: {
  item: Expense;
  canUpdate: boolean;
  canDelete: boolean;
  canDeletePosted: boolean;
  canApprove: boolean;
  onEdit: (item: Expense) => void;
  onComplete: (item: Expense) => void;
  onDelete: (item: Expense) => void;
  onHistory?: (item: Expense) => void;
}) {
  const canViewLogs = useHasPermission("expenses.view");

  if (item.locked) {
    return (
      <div className="flex items-center gap-1">
        <div
          className="flex items-center gap-1 text-muted-foreground"
          title="Dibuat dari Penggajian Rider — ubah/batalkan lewat modul Penggajian Rider"
        >
          <Lock className="h-3.5 w-3.5" />
          <span className="text-xs">Dari Payroll</span>
        </div>
        {canViewLogs && onHistory && (
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onHistory(item)}
            title="Riwayat Aktivitas"
            aria-label="Riwayat Aktivitas"
          >
            <History className="h-4 w-4" />
            <span className="sr-only">Riwayat Aktivitas</span>
          </Button>
        )}
      </div>
    );
  }

  const showDelete = canShowDeleteExpenseAction(
    item.status,
    canDelete,
    canDeletePosted,
  );

  return (
    <div className="flex items-center gap-1">
      {item.status === "draft" && (
        <>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onEdit(item)}
            disabled={!canUpdate}
            title="Edit draft"
          >
            <Pencil className="h-4 w-4" />
          </Button>
          {canApprove && (
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onComplete(item)}
              title="Selesaikan (acc)"
              className="text-emerald-600 hover:text-emerald-700"
            >
              <CheckCircle2 className="h-4 w-4" />
            </Button>
          )}
        </>
      )}
      {showDelete && (
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onDelete(item)}
          disabled={!canDelete}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      )}
      {canViewLogs && onHistory && (
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onHistory(item)}
          title="Riwayat Aktivitas"
          aria-label="Riwayat Aktivitas"
        >
          <History className="h-4 w-4" />
          <span className="sr-only">Riwayat Aktivitas</span>
        </Button>
      )}
    </div>
  );
}
